export const TEXT_KEYS = {
    MESSAGE: 'success-page__message',
    CONGRAT_MESSAGE: 'success-page__congrats-message'
};

export const GAME_PACKSHOT_CSS_VARIABLE: string = '--game-packshot-image';
